module.exports = __webpack_public_path__ + "static/img/quanyouerweima.211c0bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/live/livetest/quanyouerweima.jpg
// module id = IQn7
// module chunks = 1